// Something shared into the app from somewhere else.
//
// SCOPE, stated plainly: this handles text and links arriving as query
// parameters, and nothing else. It is not a share-sheet integration. Native
// iOS sharing and the web share target's file case both need work that does
// not exist here — a share target registration, a service worker to receive
// POSTed files, and on iOS a share extension in a native shell. A video shared
// from another app will NOT arrive through this path.
//
// The parameter names are the Web Share Target GET names (`title`, `text`,
// `url`) because that is the shape this would receive if that work were done,
// and because it costs nothing to be compatible now.
//
// NOT a mock — this is real parsing of a real URL. Pure: it takes a search
// string rather than reading `location`, so it is testable and so the caller
// controls when the URL actually changes.

const CONSUMABLE = ['url', 'text', 'title'];

// `url` first: when a share carries both, the link is the thing worth acting
// on and the text is usually the page's own title repeated back.
export function readSharedInput(search) {
  const params = new URLSearchParams(String(search || ''));
  const consumed = CONSUMABLE.filter((key) => params.has(key));

  for (const key of CONSUMABLE) {
    const value = (params.get(key) || '').trim();
    if (value) return { value, from: key, consumed };
  }

  // Present but empty still counts as consumed — leaving `?text=` in the bar
  // would re-trigger the read on every render.
  return { value: null, from: null, consumed };
}

// Removes only what was actually used. Anything else in the URL belongs to
// someone else — a feature flag, a campaign tag, a deep link — and silently
// dropping it would be a bug that only shows up in someone else's code.
export function stripConsumed(search, consumed = []) {
  const params = new URLSearchParams(String(search || ''));
  for (const key of consumed) params.delete(key);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}
